const PAYMENT_CHART_COLORS = Object.freeze({
    cleared: '#FC7C18',
    upcoming: '#C4CACE',
});

export default PAYMENT_CHART_COLORS;
